// @flow
import React, { PureComponent } from 'react';
import { View, StyleSheet } from 'react-native';
import { Separator, Text } from 'trpc-react-native-ui';
import { ConfirmationModal } from '../../../../components/common';
import OrderSummary from '../../../../components/order/OrderSummary';
import theme from '../../../../theme-config';
import I18n from '../../../../lib/i18n';

class RoamingFooter extends PureComponent<Props> {
  styles = getStyles();

  render() {
    const styles = this.styles;
    return (
      <View style={styles.container}>
        <Separator />
        {Number.isInteger(this.props.price) ? (
          <OrderSummary
            label={this.props.orderLabel}
            totalPrice={this.props.price}
            isExemptedFromTax={this.props.isExemptedFromTax}
          />
        ) : (
          <Text style={styles.pullToRefresh}>{I18n.t('RoamingOffer.pullToRefresh')}</Text>
        )}
        <ConfirmationModal
          onConfirm={this.props.onConfirm}
          openModalText={this.props.confirmText}
          disabled={this.props.disabled}
          title={I18n.t('confirmOrder')}
          confirmContent={I18n.t('RoamingOffer.confirmContent')}
          isLoading={this.props.isLoading}
        />
      </View>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    container: {
      backgroundColor: 'white',
    },
    pullToRefresh: {
      textAlign: 'center',
      fontSize: 18,
      color: theme.internationalPullToRefreshColor,
      marginTop: 10,
    },
  });

type Props = {
  price: number,
  onConfirm: Function,
  orderLabel: string,
  confirmText: string,
  disabled?: boolean,
  isExemptedFromTax: boolean,
  isLoading: boolean,
};

export default RoamingFooter;
